import { TranslationInfo } from '../translation-map';
import translationValues from './ar.json';

export const arabicTranslationInfo: TranslationInfo = {
  languageName: 'Arabic',
  languageCode: 'ar',
  direction: 'rtl',
  translations: translationValues,
};
